import React from "react";
import { useSelector } from "react-redux";

import {
  CheckBoxField,
  DisplayOptions,
  MultiLineTextField,
  SectionTitle,
  SeparatorBar,
} from "../../../components";
import { SubForm, SubFormNavigationProps } from "../../../components/SubForm";
import {
  gameInfoXboxNetworkInitialValues,
  useIdXboxGameInformationXboxNetworkValidationSchema,
} from "../../../helpers/formValidation";
import { useStrings } from "../../../localization/localizationHelpers";
import { XboxNetworkAddOns } from "../../../models/xboxNetworkAddOns";
import { XboxNetworkFeatures } from "../../../models/xboxNetworkFeatures";
import { getIsSavingForm } from "../../../redux/selectors";
import { GameInformationFormId, GameInformationSubFormsId } from "../GameInformationPageConstants";

const XboxNetworkSubForm = (props: SubFormNavigationProps) => {
  const [
    anticipatedFeatures,
    xboxNetworkFeatures,
    sharedAchievements,
    crossOwnership,
    crossSave,
    crossProgression,
    anticipatedAddOnContent,
    addOns,
    dlcPacks,
    durables,
    consumables,
    freeAddOnContent,
    describeAdditionalContent,
  ] = useStrings(
    "anticipatedFeatures",
    "xboxNetworkFeatures",
    "sharedAchievements",
    "crossOwnership",
    "crossSave",
    "crossProgression",
    "anticipatedAddOnContent",
    "addOns",
    "dlcPacks",
    "durables",
    "consumables",
    "freeAddOnContent",
    "describeAdditionalContent"
  );
  const validationSchema = useIdXboxGameInformationXboxNetworkValidationSchema();
  const isSavingFormToCrm = useSelector(getIsSavingForm);

  return (
    <SubForm
      validateConfig={validationSchema}
      initialValues={gameInfoXboxNetworkInitialValues}
      formId={GameInformationFormId}
      subFormId={GameInformationSubFormsId.XboxNetwork}
      {...props}
    >
      <SectionTitle title={anticipatedFeatures} />
      <CheckBoxField
        checkBoxes={[
          {
            value: XboxNetworkFeatures.crossOwnership,
            label: crossOwnership,
          },
          {
            value: XboxNetworkFeatures.crossSave,
            label: crossSave,
          },
          {
            value: XboxNetworkFeatures.crossProgression,
            label: crossProgression,
          },
          {
            value: XboxNetworkFeatures.sharedAchievements,
            label: sharedAchievements,
          },
        ]}
        name={"xboxNetworkFeatures"}
        title={xboxNetworkFeatures}
        display={DisplayOptions.column}
        isSaving={isSavingFormToCrm}
      />
      <SeparatorBar />
      <SectionTitle title={anticipatedAddOnContent} />
      <CheckBoxField
        checkBoxes={[
          {
            value: XboxNetworkAddOns.dlcPacks,
            label: dlcPacks,
          },
          {
            value: XboxNetworkAddOns.durables,
            label: durables,
          },
          {
            value: XboxNetworkAddOns.consumables,
            label: consumables,
          },
          {
            value: XboxNetworkAddOns.freeAddOnContent,
            label: freeAddOnContent,
          },
        ]}
        name={"addOns"}
        title={addOns}
        display={DisplayOptions.column}
        isSaving={isSavingFormToCrm}
      />
      <MultiLineTextField
        name={"additionalContent"}
        title={describeAdditionalContent}
        isSaving={isSavingFormToCrm}
      />
    </SubForm>
  );
};

export default XboxNetworkSubForm;
